import { Avatar, Box, Grid, IconButton, TextField, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { filter, map } from "lodash";
import { useContext } from "react";
import { ProjectContext } from "../../../Contexts/Project/Context";

const ManagersList: React.FC = () => {
  const { project, onManagerTitleChange, getManagerData, onProjectDataChange } = useContext(ProjectContext);

  const handleRemoval = (id?: string | null) => {
    if (!id) return;
    const newManagers = filter(
      project?.projectUsers || [],
      (user) =>
        (user.employmentId || user.companyResourceId || user.userId) !== id
    );
    onProjectDataChange("projectUsers", newManagers);
  };

  if (!project?.projectUsers?.length) return null;

  return (
    <Grid sx={{ mt: 1 }} size={12}>
      {map(project?.projectUsers || [], (manager, idx) => {
        const managerId =
          manager.employmentId ||
          manager.companyResourceId ||
          manager.userId ||
          `${idx}`;
        const manData = getManagerData(managerId);
        const managerName =
          manData?.name ||
          (manData?.user ? `${manData.user.firstName} ${manData.user.lastName}`.trim() : "") ||
          "Unknown resource";

        return (
          <Box
            key={managerId}
            sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 0.75 }}
          >
            <Avatar
              sx={{ width: 28, height: 28, flexShrink: 0 }}
              alt={managerName}
              src={(manData?.user?.imageUrl as string) || ""}
            />
            <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }} noWrap>
              {managerName}
            </Typography>
            <TextField
              size="small"
              required
              placeholder="Role / Designation"
              value={manager.title}
              error={manager.title === ""}
              onChange={(e) => onManagerTitleChange(manager, e.target.value)}
              sx={{ width: 180, flexShrink: 0 }}
              slotProps={{ htmlInput: { autoComplete: "off" } }}
            />
            <IconButton
              size="small"
              aria-label={`Remove ${managerName}`}
              onClick={() =>
                handleRemoval(
                  manager.employmentId ||
                    manager.companyResourceId ||
                    manager.userId
                )
              }
              sx={{ flexShrink: 0 }}
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>
        );
      })}
    </Grid>
  );
};

export default ManagersList;
